import { useAuth0 } from '@auth0/auth0-react';
import useSWR from 'swr';
import { AtsImportJobResponse } from './useAtsImportJob';
import ResourceNotFoundError from '@/Utils/HTTP/Errors/ResourceNotFoundError';
import http from '@/Utils/HTTP/NewHttpUtils';

export const buildActiveAtsImportJobPath = (recruitmentId: string) =>
    `recruitments/${recruitmentId}/ats-import-job/active`;

const useActiveAtsImportJob = (recruitmentId: string) => {
    const { getAccessTokenSilently } = useAuth0();

    return useSWR<AtsImportJobResponse | null>(
        buildActiveAtsImportJobPath(recruitmentId),
        async (path: string) => {
            try {
                return await http.get<AtsImportJobResponse>({
                    path,
                    accessToken: await getAccessTokenSilently(),
                });
            } catch (error) {
                // 404 means nothing is running — the ordinary case, not a failure.
                if (error instanceof ResourceNotFoundError) {
                    return null;
                }

                throw error;
            }
        },
        { revalidateOnFocus: false },
    );
};

export default useActiveAtsImportJob;
